/**
 * Imports
*/
import './moon-icons.css';
import './index.view.scss';
import './lightbox.view.scss';

// utils
import lang from '../misc/i18n.js';
import InstabergUtils from '../misc/utils.js';

import { InstabergView_LoadMore as View_LoadMore } from './loadmore.js';

// load templates views
import { InstabergViewDemo as TplDemo } from '../templates/_demo/tpl.view.js';
import { InstabergViewClassic as TplClassic } from '../templates/classic/tpl.view.js';
import { InstabergViewGrid as TplGrid } from '../templates/grid/tpl.view.js';
import { InstabergViewMasonry as TplMasonry } from '../templates/masonry/tpl.view.js';
import { InstabergViewSmallList as TplSmallList } from '../templates/listsmall/tpl.view.js';
import { InstabergViewCreative2 as TplCreative2 } from '../templates/creative2/tpl.view.js';
import { InstabergViewCreative3 as TplCreative3 } from '../templates/creative3/tpl.view.js';
import { InstabergViewMetro1 as TplMetro1 } from '../templates/metro1/tpl.view.js';
import { InstabergViewMetro2 as TplMetro2 } from '../templates/metro2/tpl.view.js';
import { InstabergViewPlaylist as TplPlaylist } from '../templates/playlist/tpl.view.js';

/**
 * WordPress dependencies
*/
const { __, _n, sprintf } = wp.i18n;
const { Component, render, findDOMNode, Fragment } = wp.element;

/**
 * Config
*/
const localizationName = 'instaberg';
const alias = 'AAInstaberg-View-';



/**
 * React Components
*/
class InstabergView extends Component {

  constructor(props) {
    super(props);

    let videos = this._get_videos();
    let { 0: video_first, length: videos_len, [videos_len-1]: video_last } = videos;
    this.state = {
      step: 0,
      showLightbox: false,
      from_lightbox: false,
      lightbox_current_videoid: '',
      current_videoid: videos_len ? video_first.id : '',
      current_post_image: '',
      current_post_type: '',
    }
  }

  render()
  {
    let { showLightbox, current_post_image, current_post_type } = this.state;
    const { layoutType } = this.props.options;
    let { options, where } = this.props;
    const { lightbox_current_videoid, from_lightbox } = this.state;

    let extra = {
      current_videoid: lightbox_current_videoid,
      from_lightbox: from_lightbox,
    };

    let { videos } = this._get_currentPageVideos( 'videos' );
    let class_css = [];
    ! showLightbox ? class_css.push('hide') : '';
    class_css = class_css.join(' ');

    return ([

      <div className={ `${alias}wrapper ${alias}layout-${layoutType} ${alias}where-${where}` }>

        { this.buildMainTemplate() }
        { this.buildLoadMore() }

        <div
          className={ `${alias}lightbox ${class_css}` }
        >
          <a href="#" className="youtube-video-cross" onClick={ (e) => { this.CloseLightbox( e ) } }></a>

          <div className={ `${alias}lightbox-content` } >

            { 'video' === current_post_type
              ?
                showLightbox
                ?
                  <TplPlaylist where={ where } videos={ videos } options={ options } extra={ extra }
                    PlSingleItem_onClick={ (pms) => { this.lightbox_PlSingleItem_onClick( pms ) } }
                  />
                : ''
              :
                ( '' !== current_post_image ? <img onClick={ (e) => { this.CloseLightbox( e ) } } src={ current_post_image } /> : '' )
            }

          </div>
        </div>

      </div>

    ]);
  }

  componentDidMount()
  {
    jQuery(`.${alias}lightbox`).appendTo('body')
  }

  CloseLightbox( event )
  {
    event.preventDefault();

    this.setState({
      showLightbox: false,
      from_lightbox: true,
    });
  }

  onClickListItem( pms )
  {
    let { videoid, image, post_type } = pms;

    this.setState({
      showLightbox: true,
      from_lightbox: true,
      lightbox_current_videoid: videoid,
      current_videoid: videoid,
      current_post_image: image,
      current_post_type: post_type,
    });
  }

  PlSingleItem_onClick( pms )
  {
    let { videoid } = pms;

    this.setState({
      current_videoid: videoid,
      from_lightbox: false,
    });
  }

  lightbox_PlSingleItem_onClick( pms )
  {
    let { videoid } = pms;

    this.setState({
      lightbox_current_videoid: videoid,
      from_lightbox: false,
    });
  }

  getTplPrefix()
  {
    const { layoutType } = this.props.options;

    let prefix = '';

    switch (layoutType) {

      case 'demo':
        prefix = 'demo';
        break;

      case 'grid':
        prefix = '';
        break;

      case 'classic':
        prefix = 'mas';
        break;

      case 'masonry':
        prefix = 'mas';
        break;

      case 'listsmall':
        prefix = 'sml';
        break;

      case 'creative2':
        prefix = 'creative2';
        break;

      case 'creative3':
        prefix = 'creative3';
        break;

      case 'metro1':
        prefix = 'metro1';
        break;

      case 'metro2':
        prefix = 'metro2';
        break;

      case 'playlist':
        prefix = 'playlist';
        break;
    }
    return prefix;
  }

  buildMainTemplate()
  {
    const { layoutType } = this.props.options;
    let { options, where } = this.props;
    const { current_videoid, from_lightbox } = this.state;
    let extra = {
      current_videoid: current_videoid,
      from_lightbox: from_lightbox,
    };
    let ret = [];

    let { videos } = this._get_currentPageVideos();
    switch (layoutType) {

      case 'demo':
        ret.push(
          <TplDemo where={ where } videos={ videos } options={ options } extra={ extra }
            onClickListItem={ (pms) => { this.onClickListItem( pms ) } }
          />
        );
        break;

      case 'classic':
        ret.push(
          <TplClassic where={ where } videos={ videos } options={ options } extra={ extra }
            onClickListItem={ (pms) => { this.onClickListItem( pms ) } }
          />
        );
        break;


      case 'grid':
        ret.push(
          <TplGrid where={ where } videos={ videos } options={ options } extra={ extra }
            onClickListItem={ (pms) => { this.onClickListItem( pms ) } }
          />
        );
        break;

      case 'masonry':
        ret.push(
          <TplMasonry where={ where } videos={ videos } options={ options } extra={ extra }
            onClickListItem={ (pms) => { this.onClickListItem( pms ) } }
          />
        );
        break;

      case 'listsmall':
        ret.push(
          <TplSmallList where={ where } videos={ videos } options={ options } extra={ extra }
            onClickListItem={ (pms) => { this.onClickListItem( pms ) } }
          />
        );
        break;

      case 'creative2':
        ret.push(
          <TplCreative2 where={ where } videos={ videos } options={ options } extra={ extra }
            onClickListItem={ (pms) => { this.onClickListItem( pms ) } }
          />
        );
        break;

      case 'creative3':
        ret.push(
          <TplCreative3 where={ where } videos={ videos } options={ options } extra={ extra }
            onClickListItem={ (pms) => { this.onClickListItem( pms ) } }
          />
        );
        break;

      case 'metro1':
        ret.push(
          <TplMetro1 where={ where } videos={ videos } options={ options } extra={ extra }
            onClickListItem={ (pms) => { this.onClickListItem( pms ) } }
          />
        );
        break;

      case 'metro2':
        ret.push(
          <TplMetro2 where={ where } videos={ videos } options={ options } extra={ extra }
            onClickListItem={ (pms) => { this.onClickListItem( pms ) } }
          />
        );
        break;

      case 'playlist':
        ret.push(
          <TplPlaylist where={ where } videos={ videos } options={ options } extra={ extra }
            PlSingleItem_onClick={ (pms) => { this.PlSingleItem_onClick( pms ) } }
          />
        );
        break;
    }
    return ret;
  }

  //============================================================================================
  // Load More related
  buildLoadMore()
  {
    const { layoutType } = this.props.options;
    let ret = [];

    let pcstyle = {
      background: this._get_option('primaryColor')['main_color'],
      fontFamily: this._get_option('primaryColor')['font_family']
    };

    if ( 'playlist' === layoutType ) {
      return '';
    }
    else if ( 'demo' !== layoutType ) {
      ret.push(
        <React.Fragment>
          <div className={ `${alias}spacer` }></div>
          <div className={ `${alias}button-wrapper` }>
            <View_LoadMore
              pcstyle={ pcstyle }
              layoutType={ layoutType }
              showLoadMore={ this.doShowLoadMore() }
              onClickLoadMore={ ( e ) => { this.onClickLoadMore( e ) } }
            />
          </div>
        </React.Fragment>
      );
      return ret;
    }

    //demo template
    ret.push(
      <div className={ `${alias}loadmore` }>
        <View_LoadMore
          pcstyle={ pcstyle }
          layoutType={ layoutType }
          showLoadMore={ this.doShowLoadMore() }
          onClickLoadMore={ ( e ) => { this.onClickLoadMore( e ) } }
        />
      </div>
    );
    return ret;
  }

  onClickLoadMore( event )
  {
    event.preventDefault();

    if ( this._canIncreaseStep() ) {
      this.setState(
        (prevState) => ({
          step: prevState.step + 1,
        }),
        () => {}
      );
    }
  }

  doShowLoadMore()
  {
    return this._get_option('showLoadMoreBtn') && this._canIncreaseStep();
  }

  //============================================================================================
  // MISC
  _get_option( opt_name )
  {
    let options = this.props.options;

    let opt = null;
    if ( InstabergUtils.isset( options, opt_name ) ) {
      opt = options[ opt_name ];
    }
    return opt;
  }

  _get_itemsPerPage( cur_step=0 )
  {
    const { layoutType } = this.props.options;
    let prefix = this.getTplPrefix();
    let cols = 'grid' === layoutType ? 'gridCols' : InstabergUtils.capitalize('gridCols'),
        rows = 'grid' === layoutType ? 'gridRows' : InstabergUtils.capitalize('gridRows');

    if ( cur_step ) {
      rows = rows + 'Step';
    }

    let nbcols = 0;
    if ( 'listsmall' === layoutType ) {
      nbcols = this._get_option( `${prefix}${cols}` );
    }
    else if ( [ 'creative2', 'creative3', 'metro1' ].includes( layoutType ) ) {
      nbcols = this._get_option( `${prefix}${cols}` );
    }
    else if ( 'metro2' === layoutType ) {
      nbcols = 6;
    }
  
    else {
      nbcols = this._get_option( `${prefix}${cols}` );
    }

    let nbrows = this._get_option( `${prefix}${rows}` );
    let itemsPerPage = 0;
    itemsPerPage = nbcols * nbrows;
    itemsPerPage = parseInt( itemsPerPage );

    return itemsPerPage;
  }

  _get_videos( { chooseType = '', selected_videos = [] } = {} )
  {
    const { layoutType } = this.props.options;
    let { videos } = this.props;

    let galleryType = this._get_option( 'galleryType' );
    if ( 'playlist' === layoutType ) {
      galleryType = 'videos';
    }

    if ( ['all', 'images', 'videos'].includes( chooseType ) ) {
      galleryType = chooseType;

      if ( selected_videos.length ) {
        videos = selected_videos;
      }
    }

    if ( 'all' === galleryType ) {
      return videos;
    }

    // filter videos
    let videos_filter = videos.slice(0);

    videos_filter.forEach( (video, key) => {

      if ( 'videos' === galleryType && 'video' !== video.post_type ) {
        videos_filter[key] = null;
      }
      else if ( 'images' === galleryType && 'image' !== video.post_type ) {
        videos_filter[key] = null;
      }
    });
    videos_filter = videos_filter.filter( item => item != null );

    return videos_filter;
  }

  _has_videos( { chooseType = '', selected_videos = [] } = {} )
  {
    let videos = this._get_videos( { chooseType, selected_videos } );
    return videos.length;
  }

  _get_currentPageVideos( chooseType='' )
  {
    const { layoutType } = this.props.options;
    let { step } = this.state;
    let videos = this._get_videos(),
        videos_len = videos.length;

    if ( 'playlist' === layoutType ) {

      return {
        videos : videos,
        start : 0,
        end : videos_len,
      };
    }

    let start = 0;
    let end = this._get_itemsPerPage( step );

    if ( step ) {
      end = this._get_itemsPerPage( 0 );
      end += parseInt( step * this._get_itemsPerPage( step ) );
    }

    if ( end > videos_len ) {
      end = videos_len;
    }

    videos = videos.slice( start, end );

    // retrieve only selected items on current page
    if ( ['all', 'images', 'videos'].includes( chooseType ) ) {

      videos = this._get_videos( { chooseType: chooseType, selected_videos: videos } );
      videos_len = videos.length;

      if ( end > videos_len ) {
        end = videos_len;
      }
    }

    return {
      videos,
      start,
      end,
    };
  }

  _canIncreaseStep()
  {
    let { step } = this.state;
    let videos = this._get_videos(),
        videos_len = videos.length;

    let end = this._get_itemsPerPage( step );
    if ( step ) {
      end = this._get_itemsPerPage( 0 );
      end += parseInt( step * this._get_itemsPerPage( step ) );
    }

    if ( end >= videos_len ) {
      return false;
    }
    return true;
  }

}
export { InstabergView };

// Instantiate for every carousel on page
document.addEventListener("DOMContentLoaded", function (event) {

    var views = document.querySelectorAll(`.${alias}wrapper`);

    for (let i = 0; i < views.length; i++) {

      var parentElm = views[i].parentNode;
      let videos = JSON.parse( parentElm.getAttribute('data-videos') ),
          options = JSON.parse( parentElm.getAttribute('data-options') );

      if ( InstabergUtils.isEmpty( videos ) || InstabergUtils.isEmpty( options ) ) {
        continue;
      }
      if ( ! InstabergUtils.isset( options, 'layoutType' ) ) {
        continue;
      }

      render(
        <InstabergView where="frontend" videos={ videos } options={ options } key={ InstabergUtils.getViewComponentKey( options, videos ) } />,
        parentElm
      );
    }
});



// WEBPACK FOOTER //
// ./wp-content/plugins/instaberg/src/gallery-view/index.view.js